import { Heading, Link, Text } from "@ttc3k/trekker";
import { Trans, useTranslation } from "react-i18next";
import { ProductTypeConfig } from "shared/config/productTypeConfig";
import { formatDate } from "shared/utils";
import { Flex } from "styled-system/jsx";

type ThankYouProps = {
  orderId: string;
  purchaseDate?: string | null;
  productTypeConfig: ProductTypeConfig;
  supportEmail: string;
};

export const ThankYou = ({
  orderId,
  purchaseDate,
  productTypeConfig,
  supportEmail,
}: ThankYouProps) => {
  const { t } = useTranslation("storefront", {
    keyPrefix: "RESERVATION_DETAILS.THANK_YOU",
  });

  return (
    <Flex flexDir="column" gap="250" w="full">
      <Flex flexDir="column" gap="50">
        <Text visual="bodySemiBold" color="text.accent.magenta.mid">
          {t("ORDER_NUMBER")} {orderId}
          {purchaseDate && ` • ${formatDate(purchaseDate, "MMM dd, yyyy")}`}
        </Text>
        <Heading size="h4">
          {t(`TITLE_${productTypeConfig.i18nKey}`)}
        </Heading>
      </Flex>
      <Text visual="bodyRegular" color="text.mid">
        <Trans
          i18nKey={`storefront:RESERVATION_DETAILS.THANK_YOU.DESCRIPTION_${productTypeConfig.i18nKey}`}
          components={{
            Link: (
              <Link
                href={`mailto:${supportEmail}`}
                textDecoration="underline"
                color="text.mid"
              />
            ),
          }}
        />
      </Text>
    </Flex>
  );
};
